<template>
    <div class="box">
        <Modal
                v-model="dialog"
                :title="$t('cloudEditor.List.editDialog.title')"
                :mask-closable="false"
                @keydown.native.enter.prevent ="debounce(save)"
        >
            <Form :model="cloudEditorSettings" :label-width="100" ref="cloudEditorForm" :rules="cloudEditorRules">
                <FormItem label="名称" style="margin-bottom: 0" prop="title">
                    <Input v-model.trim="cloudEditorSettings.title" show-word-limit :maxlength="50"/>
                </FormItem>
                <FormItem v-if="hasPermission('vrEditor')" :label="$t('directorManagement.director.editDialog.mode')" prop="type" style="margin: 20px 0 0 0 ">
                    <Select v-model="cloudEditorSettings.mode" :disabled="cloudEditorSettings.id != 0" transfer style="width: 120px" :placeholder="$t('Message.placeholderSelect')">
                        <Option :value="0">{{ $t('directorManagement.director.mode.common') }}</Option>
                        <Option :value="1">{{ $t('directorManagement.director.mode.vr') }}</Option>
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="dialog=false">{{ $t('Button.cancel') }}</Button>
                <Button type="primary" size="large" :loading="save_loading" @click="debounce(save)">{{ $t('Button.confirm') }}</Button>
            </div>
        </Modal>
        <div class="box">
            <div class="header">
                <Row v-if="hasPermission('addCloudEditor')" type="flex" class="toolbar">
                    <Col span="24">
                    <Button icon="md-add" type="primary" @click="create">{{ $t('cloudEditor.List.button.add') }}</Button>
                    </Col>
                </Row>
                <div class="filter">
                    <ul class="filter-box">
                        <li>
                            <span>{{ $t('cloudEditor.List.filter.titleLike') }}</span>
                            <Input
                                    clearable
                                    v-model="filter.titleLike"
                                    size="small"
                                    class="selector"
                                    :placeholder="$t('Message.placeholder')"
                            />
                        </li>
                        <li v-if="dep||(filter.selectType==3)">
                            <span>{{ $t('cloudEditor.List.filter.userCode') }}</span>
                            <Input
                                    clearable
                                    v-model="filter.userCode"
                                    size="small"
                                    class="selector"
                                    :placeholder="$t('Message.placeholder')"
                            />
                        </li>
                        <li>
                            <DepartmentSelect filterPath="views/cloudEditor.all.filter"></DepartmentSelect>
                        </li>
                        <li v-if="filter.selectType == 3">
                            <UserGroupSelect v-model="groupIdSelected.id" ></UserGroupSelect>
                        </li>
                    </ul>
                    <Button 
                        class="refresh-button" 
                        type="primary" 
                        size="small"
                        @click="refresh">
                        {{ $t('Button.refresh') }}
                    </Button>
                </div>
            </div>
            <div ref="list" class="content">
                <table class="list">
                    <thead>
                    <td width="50">{{ $t('cloudEditor.List.list.id') }}</td>
                    <td>{{ $t('cloudEditor.List.list.title') }}</td>
                    <td>{{ $t('cloudEditor.List.list.createDatetime') }}</td>
                    <td v-if="dep||(filter.selectType==3)">{{ $t('cloudEditor.List.list.userName') }}</td>
                    <td :width="isCordova()?50:450">{{ $t('cloudEditor.List.list.operation') }}</td>
                    </thead>

                    <tr v-for="i in list" :key="i.id">
                        <td>{{i.id}}</td>
                        <td>{{i.title}}
                            <span v-if="i.mode == Const.CloudEditor.Mode.VR" style="margin:0 5px 0 2px;position:relative;top:-1px">
                                <svg id="VRMark" style="height: 16px; vertical-align: middle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 385.62 151">
                                    <defs><svg:style>
                                        .cls-1{fill:#ffb354;} 
                                        #VRMark path{
                                            fill:#333;
                                            storke-width:0
                                        }
                                    </svg:style></defs>
                                    <title>vr</title>
                                    <rect class="cls-1" width="385.62" height="151" rx="50" ry="50"></rect>
                                    <path d="M171.69,125.07h-18.9A19.44,19.44,0,0,1,135,113.4l-2.07-4.73a7.63,7.63,0,0,0-14,0l-2.07,4.73A19.44,19.44,0,0,1,99,125.07H79.54A29.57,29.57,0,0,1,50,95.53V54.47A29.57,29.57,0,0,1,79.54,24.93h92.16a29.57,29.57,0,0,1,29.54,29.54V65.7a5.91,5.91,0,0,1-11.81,0V54.47a17.74,17.74,0,0,0-17.72-17.72H79.54A17.74,17.74,0,0,0,61.81,54.47V95.53a17.74,17.74,0,0,0,17.72,17.72H99a7.63,7.63,0,0,0,7-4.58l2.07-4.73a19.45,19.45,0,0,1,35.64,0l2.07,4.73a7.63,7.63,0,0,0,7,4.58h18.9a17.74,17.74,0,0,0,17.72-17.72,5.91,5.91,0,0,1,11.81,0A29.57,29.57,0,0,1,171.69,125.07Zm4.43-54.64A17.72,17.72,0,1,0,158.4,88.14,17.74,17.74,0,0,0,176.12,70.42Zm-11.81,0a5.91,5.91,0,1,1-5.91-5.91A5.91,5.91,0,0,1,164.31,70.42Zm-53.76,0A17.72,17.72,0,1,0,92.83,88.14,17.74,17.74,0,0,0,110.55,70.42Zm-11.81,0a5.91,5.91,0,1,1-5.91-5.91A5.91,5.91,0,0,1,98.74,70.42Z"></path><path d="M233.84,49.82h17.35l12.09,38.66,11.94-38.66h16.85l-19.95,53.72h-18Z"></path><path d="M297.71,103.54V49.82h27.67q7.69,0,11.76,1.32A12.52,12.52,0,0,1,343.7,56a14.84,14.84,0,0,1,2.49,8.7,14.36,14.36,0,0,1-7.15,13,20.07,20.07,0,0,1-5.83,2.13,16.61,16.61,0,0,1,4.32,2,16.77,16.77,0,0,1,2.65,2.83A20.94,20.94,0,0,1,342.51,88l8,15.57H331.8l-8.87-16.42a12.52,12.52,0,0,0-3-4.14,7,7,0,0,0-4.07-1.25h-1.47v21.8Zm16.67-32h7a25,25,0,0,0,4.4-.73,4.39,4.39,0,0,0,2.69-1.69,5.44,5.44,0,0,0-.61-7.11q-1.65-1.39-6.19-1.39h-7.29Z"></path>
                                </svg>
                            </span>
                        </td>
                        <td>{{ i.createDatetime }}</td>
                        <td v-if="dep||(filter.selectType==3)">{{ i.userName }}</td>
                        <td>
                            <Button
                                    v-if="hasPermission('简易云编辑功能权限')"
                                    type="dashed"
                                    size="large"
                                    icon="md-calculator"
                                    @click="simple(i)"
                            >{{ $t('cloudEditor.List.button.simple') }}</Button>
                            <Button
                                    v-if="hasPermission('专业云编辑功能权限')"
                                    type="dashed"
                                    size="large"
                                    icon="md-calculator"
                                    @click="professional(i)"
                            >{{ $t('cloudEditor.List.button.professional') }}</Button>
                            <Button
                                    v-if="hasPermission('outCloudEditor')"
                                    type="dashed"
                                    size="large"
                                    icon="md-calculator"
                                    :to="'output_task/'+i.id"
                            >{{ $t('cloudEditor.List.button.outputTask') }}</Button>
                            <Button
                                    v-if="hasPermission('editCloudEditor')"
                                    type="dashed"
                                    size="large"
                                    icon="md-settings"
                                    @click="edit(i)"
                            >{{ $t('Button.edit') }}</Button>
                            <Button
                                    v-if="hasPermission('deleteCloudEditor')&&(i.userId==userId)"
                                    type="dashed"
                                    size="large"
                                    icon="md-close"
                                    @click="remove(i)"
                            >{{ $t('Button.remove') }}</Button>
                        </td>
                    </tr>
                </table>

                <Spin v-show="loading" fix class="spin">
                    <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
                    <div>Loading</div>
                </Spin>
                <Page
                        class="pager"
                        :total="pagination.total"
                        :current="pagination.page"
                        :page-size="pagination.pageSize"
                        @on-change="v=>pagination.page=v"
                        @on-page-size-change="v=>pagination.pageSize=v"
                        show-elevator
                        show-sizer
                        transfer
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import api from "@/api/Api";
    import { Const } from "@/model/ApiModel";
    import extend from "extend";
    import config from "@/config"
    import DepartmentSelect from "../../../components/DepartmentSelect"
    import UserGroupSelect from "../../../components/UserGroupSelect"
    import HtmlDecode from "@/plugins/htmlDecode";
    export default {
        components: {
            DepartmentSelect,
            UserGroupSelect
        },
        data(){
            return {
                groupIdSelected: {
                    id: this.$store.state.user.defaultSelectedUserGroup,
                    groupData: []
                },
                Const,
                loading: false,
                save_loading: false,
                dialog: false,
                dialog_loading: false,
                list: [],
                cloudEditorSettings: this.newCloudEditor(),
                cloudEditorRules: {
                    "title": [
                        { required: true, message: this.$t('Message.save.nameEmpty'), trigger: "blur" },
                        { max: 50, message: this.$t('Message.save.nameLength'), trigger: "blur" },
                        { trigger: "blur", validator: (rule, value, callback) => {
                                if (value.trim() == "") {
                                    callback(new Error(this.$t('Message.save.nameEmpty')));
                                } else {
                                    callback();
                                }
                            }
                        }
                    ]
                }
            }
        },
        computed: {
            filter: {
                get() {
                    return this.$store.state.views.cloudEditor.all.filter;
                },
                set(v) {
                    this.$store.commit("views/cloudEditor.all.filter", v);
                }
            },
            pagination: {
                get() {
                    return this.$store.state.views.cloudEditor.all.pagination;
                },
                set(v) {
                    this.$store.commit("views/cloudEditor.all.pagination", v);
                }
            },
            ...mapState({
                globalConfig: state => state.user.globalConfig,
                // enableVr: state => state.config.vrEditor,
                departmentName: state => state.department.currentName,
                departmentId: state => state.department.currentId,
                userId: state => state.user.id,
                shareId: state => state.user.defaultSelectedUserGroup,
                userCode: state => state.user.userCode
            }),
            dep(){
                return this.filter.selectType == 2
            }
        },
        watch: {
            'groupIdSelected.id'(){
                this.pagination.page = 1;
                this.refresh(); 
            },
            'filter.depId'() {
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.titleLike'() {
                if(this.containsInvaildChar(this.filter.titleLike)){
                    return;
                }
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.userCode'() {
                this.pagination.page = 1;
                this.refresh();
            },
            "pagination.page": "refresh",
            "pagination.pageSize": "refresh"
        },
        methods: {
            //简易
            simple({id, userId, mode}){
                let url = config.cloudEditorUrl
                        .replace("{{id}}", id)
                        + "&simple&mId=" + userId + (mode ? '&vrmode' : '') 
                        + "&selectType=" + this.filter.selectType;
                window.open(url, "_blank")
            },
            professional({id, userId, mode}){
                let url = config.cloudEditorUrl
                        .replace("{{id}}", id)
                        + "&mId=" + userId + (mode ? '&vrmode' : '')
                        + "&selectType=" + this.filter.selectType;
                window.open(url, "_blank")
            },
            edit(item){
                this.dialog = true;
                Object.assign(this.cloudEditorSettings, item);
            },
            create(){
                this.dialog = true;
                this.cloudEditorSettings = this.newCloudEditor();
            },
            newCloudEditor() {
                return {
                    id: 0,
                    title: "",
                    mode: 0
                };
            },
            async save(){
                if(this.hasPermission('saveCloudEditor')){
                    this.save_loading = true;
                    this.cloudEditorSettings.title = this.cloudEditorSettings.title.trim();
                    if(this.cloudEditorSettings.title == ""){
                        this.$Message.error(this.$t('Message.save.nameEmpty'))
                    }else {
                        try {
                            let ret = await api.call("cloudEditor/save", this.cloudEditorSettings);

                            this.$Notice.success({ title: this.$t('Message.save.success') });

                            this.dialog = false;
                            this.refresh();
                        } catch (e) {
                            this.$Notice.error({ title: this.$t('Message.save.error'), desc: e.resultMsg });
                        }
                    }
                    setTimeout(()=>{
                        this.save_loading = false;
                    },2000);
                }else {
                    this.$Notice.error({ title: this.$t('Message.permission.error') });
                }

            },
            async remove({id, title}) {
                if (!confirm(this.$t('Message.remove.confirm') + `(${title}) ?`)) return;

                this.loading = true;

                try {
                    let ret = await api.call("cloudEditor/delete", {
                        id: id
                    });

                    this.$Notice.success({ title: this.$t('Message.remove.success') + `(${title})` });

                    this.refresh();
                } catch (e) {
                    this.$Notice.error({ title: this.$t('Message.remove.error') + `(${title})`, desc: e });
                }

                this.loading = false;
            },
            async refresh() {
                this.loading = true;
                let param = extend(true, {}, this.pagination, this.filter);
                if(this.filter.selectType == 3){
                    param.shareId = this.shareId
                }
                try {
                    let ret = await api.call(
                        "cloudEditor/list",
                        param
                    );
                    // decode name for ret.list if ret.list is valid
                    if (ret.list && ret.list.length > 0) {
                        ret.list.forEach(item => {
                            item.title = HtmlDecode.d(item.title);
                        });
                    }
                    this.list = ret.list;
                    this.pagination.total = ret.total;
				} catch (e) {
					this.$Notice.error({
						title: this.$t(e && e.reject ?
							'Message.permission.error' :
							'Message.callResult.retry')
					});
					this.list = [];
                    this.pagination.total = 0 ;
                }

                this.loading = false;
            }
        },
        mounted() {
            this.refresh();
        }
    }
</script>

<style lang="less" scoped>
    @keyframes spin1 {
        from {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(180deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    .box {
        min-height:400px
    }
    .header {
        & > * {
            margin-bottom: 10px;
            border-radius: 5px;
        }
        .toolbar {
            height: 32px;
            line-height: 32px;

            button {
                margin-right: 22px;
                vertical-align: middle;
            }

            .search {
                width: 200px;
            }
        }
        .filter {
            padding: 10px 20px;
            background: #fff;

            .filter-box {
                list-style: none;
                display: inline-block;
                & > li {
                    display: inline-block;
                }
            }
        }
    }
    .content {
        position: relative;
        border-radius: 5px;
        background: white;
        padding: 0 20px;

        .spin {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
    }
    .list {
        width: 100%;
        border-radius: 5px;
        border-collapse: collapse; /*表格的边框合并，如果相邻，则共用一个边框*/
        border-spacing: 0; /*设置行与单元格边框的间距。当表格边框独立（即border-collapse:separate;）此属性才起作用*/

        td {
            padding: 12px 0;
            border-bottom: 1px solid #e9e9e8;
        }
    }
    .pager {
        text-align: center;
        padding: 10px;
    }

    .selector {
        display: inline-block;
        width: auto;
    }
</style>